import React from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';
import { Translate } from 'react-localize-redux';

const T = 'hospital.my-corrections.out-of-scope';

interface WebSessionOutOfScopeNoticeProps {
    open: boolean;
    onBackToCorrections: () => void;
    onClose: () => void;
}

/**
 * SKIN-600 — the API refused something outside a dermatologist's correction work
 * (`403 WEB_SESSION_OUT_OF_SCOPE`). The session is kept; this says why the screen is empty and
 * leads back to My corrections.
 */
export default function WebSessionOutOfScopeNotice({ open, onBackToCorrections, onClose }: WebSessionOutOfScopeNoticeProps) {
    if (!open) return null;
    return (
        <Alert
            severity="info"
            data-testid="web-session-out-of-scope"
            onClose={onClose}
            sx={{ m: 2 }}
            action={(
                <Button color="inherit" size="small" onClick={onBackToCorrections} data-testid="back-to-corrections">
                    <Translate id={`${T}.back`} />
                </Button>
            )}
        >
            <AlertTitle><Translate id={`${T}.title`} /></AlertTitle>
            <Translate id={`${T}.body`} />
        </Alert>
    );
}
